import { render } from "./PreprintList.vue?vue&type=template&id=01f741a4&scoped=true"
import script from "./PreprintList.vue?vue&type=script&lang=js"
export * from "./PreprintList.vue?vue&type=script&lang=js"

import "./PreprintList.vue?vue&type=style&index=0&id=01f741a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f741a4"]])

export default __exports__